import React from "react";
import { ourStory } from "../mock";
import useReveal from "../hooks/useReveal";

export default function OurStory() {
  const [ref, visible] = useReveal();
  return (
    <section id="story" className="py-20 md:py-28 px-6">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center reveal ${
          visible ? "is-visible" : ""
        }`}
      >
        {/* Overlapping images */}
        <div className="relative h-[420px] md:h-[540px]">
          <div className="img-zoom absolute right-0 top-0 w-[72%] h-[78%] border-[6px] border-[#F4EFE6] shadow-xl">
            <img src={ourStory.imgMain} alt="Our story" className="w-full h-full object-cover" />
          </div>
          <div className="img-zoom absolute left-0 bottom-0 w-[52%] h-[54%] border-[6px] border-[#F4EFE6] shadow-2xl">
            <img src={ourStory.imgOverlay} alt="Our story detail" className="w-full h-full object-cover" />
          </div>
        </div>

        {/* Text */}
        <div>
          <h2 className="font-serif-display text-[#9E2B25] text-[46px] md:text-[64px] leading-none">
            {ourStory.title}
          </h2>
          <p className="mt-8 font-serif-display text-[24px] md:text-[28px] leading-snug text-[#211E1A]">
            {ourStory.lead}
          </p>
          {ourStory.paragraphs.map((p, i) => (
            <p key={i} className="mt-5 text-[#4a443d] leading-relaxed">
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
